import axios from 'axios';
import type { AlmanacCalendarProviderType } from '@bb/domain/dist/types';

const isAuthenticatedForAgent = async () => {
  const config = {
    url: `/user/coop/almanac/auth_status`,
    method: 'get' as const,
  };

  const { data } = await axios.request<{
    isAuthenticated: boolean;
    calendarProvider: AlmanacCalendarProviderType;
    showBuyerShowingsAsBusy: boolean;
    showListingShowingsAsBusy: boolean;
  }>(config);
  return data;
};

export default isAuthenticatedForAgent;
